// reactjs.org/docs/lists-and-keys.html#keys

let _uniqueKey = 0;

export default function uniqueKey () {
  return (++_uniqueKey).toString();
}
